<template>
  <div class="auth-callback-container">
    <div class="uk-text-center">
      <div class="spinner-container">
        <div uk-spinner="ratio: 3"></div>
      </div>
      <h3 class="auth-message">{{ message }}</h3>
      <div class="auth-logo"></div>
    </div>
  </div>
</template>

<script>
import { processAuthCallback } from '@/utils/authCallback';
import { USER_REQUEST } from '@/store/actions/user';
import { AUTH_SUCCESS } from '@/store/actions/auth';
import axios from 'axios';

export default {
  name: 'AuthCallback',
  data() {
    return {
      message: 'Processing authentication...',
      isLoading: true
    };
  },
  created() {
    // Make axios available to the component
    this.$axios = axios;
    
    // Set body background to black
    document.body.classList.add('auth-callback-page');
  },
  destroyed() {
    // Remove the black background when component is destroyed
    document.body.classList.remove('auth-callback-page');
  },
  mounted() {
    // Process the auth callback data
    const authData = processAuthCallback();
    
    // If no auth data was found, show an error message
    if (!authData) {
      this.message = 'Authentication failed. Please try again.';
      this.isLoading = false;
      
      // Redirect to home page after a delay
      // setTimeout(() => {
      //   this.$router.push('/');
      // }, 3000);
    } else if (authData.result === false) {
      // Handle error case
      this.message = `Authentication failed: ${authData.err || 'Unknown error'}`;
      this.isLoading = false;
      
      // Redirect to login page after error
      setTimeout(() => {
        this.$router.push('/login');
      }, 3000);
    } else if (authData.accessToken) {
      this.message = 'Authentication successful. Redirecting...';
      
      // Store the token in localStorage
      localStorage.setItem("user-token", authData.accessToken.access_token);

      // Set up axios headers
      // this.$axios.defaults.headers.common["Authorization"] =
      //   authData.accessToken.access_token;
      
      // // Commit the auth success mutation
      // this.$store.commit('AUTH_SUCCESS', {
      //   data: { access_token: authData.accessToken.access_token },
      // });
      
      // Dispatch user request to get user data and wait for it to complete
      this.$store.dispatch('USER_REQUEST').then((resp) => {
        console.log('finished', resp)
        // Redirect after user data has been stored in localStorage
        setTimeout(() => {
          console.log('checking localstorage has user')
          // if(localStorage.getItem('user')) {
          //   window.location.href = '/';
          // }
        }, 10000)
      }).catch(error => {
        console.error('Error fetching user data:', error);
        // Redirect anyway after a delay
        // setTimeout(() => {
        //   window.location.href = '/';
        // }, 1000);
      });
      
      // Redirect to home page after successful login
    } else {
      this.message = 'Authentication successful. Redirecting...';
      
      // Redirect to home page after a delay
      // setTimeout(() => {
      //   this.$router.push('/');
      // }, 1500);
    }
  }
};
</script>

<style scoped>
.auth-callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
  background-color: #000;
  color: #fff;
}

.spinner-container {
  margin: 40px 0;
}

.auth-message {
  font-size: 24px;
  margin: 20px 0;
  font-weight: 300;
}

.auth-logo {
  width: 150px;
  height: 50px;
  background-image: url('/assets/img/logo.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 30px auto;
}

/* Add a pulsing animation to the spinner */
@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

[uk-spinner] {
  animation: pulse 2s infinite ease-in-out;
}
</style>

<style>
/* Global styles for auth callback page */
body.auth-callback-page {
  background-color: #000;
  color: #fff;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
</style>
